import React from 'react'
import Footer from '../../componets/General/Footer';
import NavBar from '../../componets/General/NavBar';

class RelojAnalogico extends React.Component {
    state = {

    }
    componentWillUnmount(){
        clearInterval(this.state.interval);
    }
    componentDidMount(){
        
        window.scrollTo(0,0);

        const updateHour = () => {
            var canvas = document.getElementById("canvas");
            var contex = canvas.getContext("2d");
            var radioReloj = canvas.width / 2;
        
            //reloj circulo
            contex.beginPath();
            contex.fillStyle = "black";
            contex.arc(radioReloj,radioReloj,radioReloj,0,2*Math.PI);
            contex.fill();
        
            //centro blanco
            contex.beginPath();
            contex.fillStyle = "white";
            contex.arc(radioReloj,radioReloj,10,0,2*Math.PI);
            contex.fill();
        
            //numeracion
            contex.font = radioReloj/10 + "px Arial";
            contex.textAlign = "center";
            contex.textBaseLine = "middle";
              for (var i = 1; i <= 12; i++) {
                contex.fillText(i, radioReloj + radioReloj * 0.9 * Math.sin(i * 2 * Math.PI / 12) ,radioReloj - radioReloj * 0.9 * Math.cos(i * 2 * Math.PI / 12));
            }
        
            //tiempo
            var horas = new Date().getHours();
            var minutos = new Date().getMinutes();
            var segundos = new Date().getSeconds();
        
            var hora = horas % 12 + minutos / 60 + segundos / 3600;
        
            var anguloHoras = hora * 2 * Math.PI/12;
            var anguloMinutos = minutos * 2 * Math.PI/60;
            var anguloSegundos = segundos * 2 * Math.PI/60;
        
            //manecilla hora
            contex.strokeStyle = "white";
            contex.moveTo(radioReloj,radioReloj);
            contex.lineTo( radioReloj + radioReloj * 0.6 * Math.sin(anguloHoras) ,radioReloj - radioReloj * 0.6 * Math.cos(anguloHoras));
            contex.lineWidth = 5;
            contex.stroke();
        
            //manecilla minutos
            contex.strokeStyle = "white";
            contex.moveTo(radioReloj,radioReloj);
            contex.lineTo( radioReloj + radioReloj * 0.8 * Math.sin(anguloMinutos) ,radioReloj - radioReloj * 0.8 * Math.cos(anguloMinutos));
            contex.lineWidth = 3;
            contex.stroke();
        
            //manecilla minutos
            contex.strokeStyle = "white";
            contex.moveTo(radioReloj,radioReloj);
            contex.lineTo( radioReloj + radioReloj * 0.9 * Math.sin(anguloSegundos) ,radioReloj - radioReloj * 0.9 * Math.cos(anguloSegundos));
            contex.lineWidth = 2;
            contex.stroke();
          }
          this.setState({interval:setInterval(updateHour,1000)});  
    }
    render(){
        return(
            <>
            <NavBar/>
            <div className = "my-5 text-center">
                <canvas id="canvas" width=" 300" height="300"></canvas>
            </div>
            
            <Footer/>
            </>
        )
    }
}

export default RelojAnalogico